import { QueryKey as OriginQueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { QUERY_KEY } from '@query/keys';
import { ApiRepository } from '@repositories/api';

import type {
  ChannelTotalTransactionAmountResumptionResponseError,
  ChannelTotalTransactionAmountResumptionResponseOK,
  GetChannelTotalTransactionAmountResumptionRequestPayload
} from '@repositories/api/dashboard.types';
import type { AxiosResponse } from 'axios';

type Props<Data extends AxiosResponse, ErrorResponse, QueryKey extends OriginQueryKey> = {
  queryParams: GetChannelTotalTransactionAmountResumptionRequestPayload['queryParams'];
  options?: Omit<
    UseQueryOptions<Data, ErrorResponse, Data['data']['data'], QueryKey>,
    'queryKey' | 'queryFn' | 'initialData'
  >;
};

function useGetChannelMonthlyTotalTransactionAmountResumptionQuery<
  Data extends ChannelTotalTransactionAmountResumptionResponseOK,
  ErrorResponse extends ChannelTotalTransactionAmountResumptionResponseError
>({
  queryParams,
  options
}: Props<
  Data,
  ErrorResponse,
  ReturnType<typeof QUERY_KEY.DASHBOARD.GET_CHANNEL_MONTHLY_TOTAL_TRANSACTION_AMOUNT_RESUMPTION>
>) {
  return useQuery({
    queryKey: QUERY_KEY.DASHBOARD.GET_CHANNEL_MONTHLY_TOTAL_TRANSACTION_AMOUNT_RESUMPTION({
      queryParams
    }),
    queryFn: () => {
      return ApiRepository.dashboard.getChannelMonthlyTotalTransactionAmountResumption({
        queryParams
      });
    },
    select: (data) => data.data.data,
    ...options
  });
}

export { useGetChannelMonthlyTotalTransactionAmountResumptionQuery };
